module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('aside', {
    staticClass: "menu app-sidebar-right animated"
  }, [_c('article', {
    staticClass: "tile is-child box"
  }, [_c('collapse', [_c('collapse-item', {
    attrs: {
      "title": "Components"
    }
  }, [_vm._v("\n            Lorem ipsum dolor sit amet, consectetur adipiscing elit. Phasellus nec iaculis mauris. @bulmaio. #css\n            #responsive\n          ")]), _vm._v(" "), _c('collapse-item', {
    attrs: {
      "title": "Elements"
    }
  }, [_vm._v("\n            Lorem ipsum dolor sit amet, consectetur adipiscing elit. Phasellus nec iaculis mauris. @bulmaio. #css\n            #responsive\n          ")]), _vm._v(" "), _c('collapse-item', {
    attrs: {
      "title": "Nests"
    }
  }, [_c('collapse', [_c('collapse-item', {
    attrs: {
      "title": "Nest Child"
    }
  }, [_vm._v("\n                Lorem ipsum dolor sit amet, consectetur adipiscing elit. Phasellus nec iaculis mauris. @bulmaio. #css\n                #responsive\n              ")])], 1)], 1)], 1)], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-c0378d74"}!./~/vue-loader/lib/selector.js?type=template&index=0!./client/components/layout/RightSidebar.vue
// module id = 167
// module chunks = 34